import React, { useEffect, useState } from "react";
import { BaseDraggable } from "./BaseDraggable";
import { useStore } from "../../stores/store";
import { DraggableKeys } from "../../interfaces/config";
import CoordinateConversion from "@arcgis/core/widgets/CoordinateConversion";

const key = DraggableKeys.XY_COORDINATES_DRAGGABLE;

export default function CoordinatesDraggable() {
  const { isActive, toggleActiveItem, mapView } = useStore();
  const coordinatesWidgetRef = React.useRef<HTMLDivElement>(null);

  const isInitialized = React.useRef(false);

  useEffect(() => {
    if (!mapView || !coordinatesWidgetRef.current || isInitialized.current) return;
    const coordinateConversion = new CoordinateConversion({
      view: mapView,
      container: coordinatesWidgetRef.current,
    });
    coordinateConversion.formats = coordinateConversion.formats.filter((format) => ["xy", "basemap"].includes(format.name));
    isInitialized.current = true;

  }, [mapView, coordinatesWidgetRef, isInitialized.current]);

  return (
    <BaseDraggable
      id={key}
      onClose={() => toggleActiveItem(key)}
      visible={isActive(key)}
      initialPosition="top-right"
      headerText="XY COORDINATES"
      size="auto"
    >
      <div>
        <div ref={coordinatesWidgetRef} />
      </div>
    </BaseDraggable>
  );
}
